import { call, put, takeLatest } from "redux-saga/effects";
import axios from 'axios';
import {
  authCheckFail,
  authCheckSuccess,
  getCurrentUserError,
  GetCurrentUserRequestAction,
  getCurrentUserSuccess
} from '../actions';
import type { ReceiveLoginRequestAction, AuthCheckRequestAction  } from "../actions";
import {
  AUTH_CHECK_REQUEST,
  AUTH_EXPIRED,
  GET_CURRENT_USER_REQUEST,
  RECEIVE_LOGIN_REQUEST
} from '../../../common/constants/action-constants';
import UserService from "../../../common/services/user.service";
import ApiService from "../../../common/services/api.service";
import AlertService from "../../../common/services/notification.service";
import { notificationMessage } from "../../../common/constants/notication-constants";
import { receiveLPSConfigsRequest, startCountLPSDataRequest } from '../../lps-form/actions';
import { receiveSettingsRequest } from '../../search/actions/settings';

/**first user checking after google login**/
function* getUserWithAuth(action: ReceiveLoginRequestAction) {
  try {
    // save token in LocalStorage
    if (action.token) {
      UserService.setToken = action.token;
    }
    const currentUser = yield call(ApiService.post, "/login", {
      code: action.code,
    });
    if (currentUser && currentUser.data.token) {
      UserService.setToken = currentUser.data.token;
      yield put(authCheckSuccess());
    }
    const { name } = currentUser.data.user;
    if (currentUser && currentUser.data.default_lps_profile) {
      const selectedConfig = currentUser.data.default_lps_profile;
      // yield delay(2000);
      console.log("LPS process started");
      const ident = Date.now();
      // dispatch(startCountLPSDataRequest({ selectedConfig, selectedCity, ident }));
      yield put(
        startCountLPSDataRequest({
          selectedConfig,
          selectedCity: "All cities",
          ident,
        })
      );
      // AlertService.info(notificationMessage.LPS_CALCULATION_START);
    }

    yield put(getCurrentUserSuccess(currentUser.data.user));
    yield call(AlertService.success,`${notificationMessage.LOGIN_SUCCESS}, ${name}!`);
    action.navigate("/dashboard");
    yield put(receiveSettingsRequest());
    yield put(receiveLPSConfigsRequest());
    // action.cb();
  } catch (error) {
    yield put(getCurrentUserError(error));
    AlertService.error(notificationMessage.PERMISSIONS_ERROR);
    UserService.logout();
    action.navigate("/login");
  }
}

/**get user from server during application work**/
function* getCurrentUser(action: GetCurrentUserRequestAction) {
  try {
    if (!UserService.token) return;
    const currentUser = yield call(ApiService.get, "/current-user");
    if ( currentUser !== undefined && currentUser !== null) {
      yield put(getCurrentUserSuccess(currentUser.data.user));
    }
  } catch (error) {

    // AlertService.error(notificationMessage.PERMISSIONS_ERROR);
    UserService.logout();
    action.navigate("/login");
  }
}

function* authExpiredWorker() {
  UserService.logout();
  yield put(authCheckFail());
}

function* authCheckWorker(_action: AuthCheckRequestAction) {
  try {
    if (!UserService.token) {
      yield put(authCheckFail());
      return;
    }
    const currentUser = yield call(ApiService.get, "/current-user");
    if (currentUser?.data?.user) {
      yield put(getCurrentUserSuccess(currentUser.data.user));
      yield put(authCheckSuccess());
    } else {
      yield put(authCheckFail());
    }
  } catch (error: unknown) {
    const status = axios.isAxiosError(error) ? error.response?.status : undefined;
    if (status === 401 || status === 403) {
      yield put(authCheckFail());
      return;
    } else {
      yield put(getCurrentUserError(error));
      yield put(authCheckFail());
    }
  }
}

export default function* actionLogin() {
  yield takeLatest(RECEIVE_LOGIN_REQUEST, getUserWithAuth);
  yield takeLatest(GET_CURRENT_USER_REQUEST, getCurrentUser);
  yield takeLatest(AUTH_CHECK_REQUEST, authCheckWorker);
  yield takeLatest(AUTH_EXPIRED, authExpiredWorker);
}
